export default {
    setBaseInfo(state, payload) {
        state.base = payload
    },
    setDomains(state, payload) {
        state.domains = payload
    },
    setWxAuthorityUrl(state, payload) {
        state.authorityUrl = payload
    },
    setSelectMiniProgram(state, payload) {
        state.miniPrograms = payload
    },
    setWxPages(state, payload) {
        state.wxPages = payload
    },
    setWxCategoryList(state, payload) {
        state.wxCategoryList = payload
    }
}
